import { useDispatch, useSelect } from '@wordpress/data';
import IS_REDUCED_MOTION_STORE from './store';
/**
 * @return {[boolean, (isReducedMotion: boolean) => void]}
 */

export var useReducedMotion = function () {
  var isReducedMotion = useSelect(function (select) {
    return select(IS_REDUCED_MOTION_STORE).getIsReducedMotion();
  });

  var _useDispatch = useDispatch(IS_REDUCED_MOTION_STORE),
      setIsReducedMotion = _useDispatch.setIsReducedMotion;

  return [
  /** @type {boolean} */
  isReducedMotion, setIsReducedMotion];
};